const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

// The ticket's base price and its options are stored independently. Each
// selected option tracks its own sales counter, so its surcharge must be
// included in the ticket revenue displayed in the organiser dashboard.
export const getTicketRevenue = (ticket) => {
  const baseRevenue = toAmount(ticket?.amountSold) * toAmount(ticket?.price);
  const optionsRevenue = (Array.isArray(ticket?.options) ? ticket.options : []).reduce(
    (total, group) =>
      total +
      (Array.isArray(group?.values) ? group.values : []).reduce(
        (groupTotal, value) =>
          groupTotal + toAmount(value?.amountSold) * toAmount(value?.priceDelta),
        0,
      ),
    0,
  );

  return baseRevenue + optionsRevenue;
};
